import { Resource } from '../../http/resource/resource.model';
// tslint:disable: variable-name

export class LoginField extends Resource {
  // id is inherited from Resource
  id: number;
  type: any;
  label: any;
  main_setting_id: number;
  portal_id?: number;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
}
